import Mock from 'mockjs';
import MockRequest, { AjaxDate } from '../MockRequest';

export function queryJobBasicInfo(data: AjaxDate) {
  console.log(data);
  return new MockRequest(
    Mock.mock({
      id: '@guid',
      jobName: '作业-@cword(1,20)',
      jobKnowledge: '@cword(2,50)',
      jobInfomation: '@cword(2,100)',
    }), '请求成功', true,
  );
}

export function saveJobBasicInfo(data: AjaxDate) {
  const d = JSON.parse(data.body);
  return new MockRequest(Mock.mock({
    ...d,
    id: '@guid',
  }), '请求成功', true);
}

export function delJobBasicInfo(data: AjaxDate) {
  const { ids } = JSON.parse(data.body);
  return new MockRequest(
    ids, '删除成功', true,
  );
}

export function test() { return {}; }
